import CollectPaymentButton from "@/app/components/ui/Buttons/CollectPaymentButton";
import NumberInput from "@/app/components/ui/Inputs/NumberInput";
import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";
import { useSnapmintEmiStatusAPI } from "@/app/hooks/api_hooks/Cart/useSnapmintEmiStatusAPI";
import { ISnampmintPayment, useSnapmintPaymentAPI } from "@/app/hooks/api_hooks/Cart/useSnapmintPaymentAPI";
import useFormValidations from "@/app/hooks/useFormValidations";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { BsCurrencyRupee } from "react-icons/bs";
import SnapmintPaymentCancelModal from "../SnapmintPaymentCancelModal";
import { FaWhatsapp } from "react-icons/fa";
import { useSeuseSnapmintPaymentLinkAPI } from "@/app/hooks/api_hooks/Cart/useSnapmintPaymentLink";

const SnapmintIntegration = ({
  emi_meta_data,
  setPaidSnapmintInvoices,
  setIsSnapmintValue,
  setIsSnapmintValueButton,
  removeSnapmintPaymentMethod,
  orderId,
  order_status,
  setOrderId,
  setOrder_status,
  cancelPaymentInProgress,
}) => {
  const { forOnlyNumbersWithDecimal } = useFormValidations();
  const { getRouteKey } = useRouter();
  const { customerId, customerDetails } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState
    .state as ICustomerProfileState;
  const { mappedClinicId, mappedClinicName } = useAppSelector((state) => state.root.UIStates);
  const [isProcessing, setIsProcessing] = useState(false);
  const [emiStatusLoading, setEmiStatusLoading] = useState(false);
  const [sendpaymentLink, setSendpaymentLink] = useState(false);
  const { execute: paySnapmintEMI } = useSnapmintPaymentAPI();
  const { execute: fetchEmiDetails, emi_status } = useSnapmintEmiStatusAPI();
  const [customerMobile, setCustomerMobile] = useState(null);
  const [isSMSbuttonVisible, setIsSMSbuttonVisible] = useState(false);
  const [isSMSbuttonDisable, setIsSMSbuttonDisable] = useState(false);
  const { execute: sendSnapmintPaymentLinkAPI } = useSeuseSnapmintPaymentLinkAPI();
  const skipInitialRef = useRef(false);

  // const [emiStatus, setEmiStatus] = useState<string | null>(null);

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {},
  });

  //FromHook
  const { formState } = formHook;

  useEffect(() => {
    if (order_status === "pending" && !skipInitialRef.current) {
      setIsSMSbuttonVisible(true);
    }
  }, [order_status]);

  // Function to handle payment with Snapmint
  const handleCollectPayment = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsProcessing(true);

    const emi_collect_payload: ISnampmintPayment = {
      user_id: customerId,
      clinic_id: mappedClinicId,
      clinic_name: mappedClinicName,
      mobile_number: customerMobile,
      emi_collect_amount: parseFloat(formHook.getValues(`emi_collect_amount`)) || 0,
      invoice_ids: emi_meta_data?.snapmint_invoice_wise_line_item?.map((e) => e.invoice_id) || [],
    };
    paySnapmintEMI(emi_collect_payload).then(({ status, message }) => {
      if (status) {
        setIsProcessing(false);
        setOrderId(message?.order_id || null);
        fetchEmiDetails(message?.order_id);
        skipInitialRef.current = true;
        setOrder_status(message?.order_status);
        setIsSMSbuttonVisible(false); // Hide send button first
        const timer = setTimeout(() => {
          setIsSMSbuttonVisible(true); // Show after 30 sec
          skipInitialRef.current = false;
        }, 30 * 1000);
        return () => clearTimeout(timer);
      } else {
        setIsProcessing(false);
      }
    });
  };

  const handelFetchSnapmintEMIData = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setEmiStatusLoading(true);
    fetchEmiDetails(
      emi_meta_data?.last_pending_order?.order_status === "pending"
        ? emi_meta_data?.last_pending_order?.order_id
        : orderId,
    ).then(() => {
      setEmiStatusLoading(false);
      // setPaidSnapmintInvoices;
    });
  };

  useEffect(() => {
    if (order_status === "cancel") {
      formHook.setValue(`emi_collect_amount`, 0);
    }
  }, [order_status]);

  useEffect(() => {
    if (emi_meta_data) {
      setOrder_status(emi_meta_data?.last_pending_order?.order_status?.toLowerCase());
      setOrderId(emi_meta_data?.last_pending_order?.order_id);
      formHook.setValue(
        "emi_collect_amount",
        emi_meta_data?.last_pending_order?.order_status === "pending"
          ? emi_meta_data?.last_pending_order?.order_value
          : emi_meta_data?.snapmint_total_eligible_amount,
      );
    }
  }, [emi_meta_data]);
  useEffect(() => {
    if (customerDetails?.mobile) {
      setCustomerMobile(customerDetails?.mobile);
    }
  }, [customerDetails]);

  useEffect(() => {
    const emi_collect_amount = formHook.getValues(`emi_collect_amount`);

    if (emi_collect_amount && emi_collect_amount > 0) {
      setIsSnapmintValue(emi_collect_amount);
      setIsSnapmintValueButton(emi_collect_amount);
    } else {
      setIsSnapmintValue(0);
      setIsSnapmintValueButton(0);
    }
  }, [formHook.watch(`emi_collect_amount`)]);

  useEffect(() => {
    if (emi_status?.order_status === "settled") {
      setIsSnapmintValueButton(0);
      setPaidSnapmintInvoices(emi_status);
      setOrder_status(emi_status?.order_status);
    }
  }, [emi_status?.order_status]);

  useEffect(() => {
    if (customerMobile) {
      formHook.setValue("mobile", customerMobile);
    }
  }, [customerMobile]);
  useEffect(() => {
    const mobile = formHook.watch("mobile");
    if (mobile?.length === 10) {
      setCustomerMobile(mobile);
    }
  }, [formHook.watch("mobile")]);

  const sendSnapmintPaymentLink = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSendpaymentLink(true);
    setIsSMSbuttonDisable(true);
    const smsData = {
      user_id: customerId,
      order_id: orderId,
    };

    sendSnapmintPaymentLinkAPI(smsData).then(({ status }) => {
      setSendpaymentLink(false);
      if (status) {
        setIsSMSbuttonDisable(true);
        const timer = setTimeout(() => {
          setIsSMSbuttonDisable(false);
        }, 30 * 1000); // 30 seconds
        return () => clearTimeout(timer); // cleanup on unmount
      }
    });
  };

  // Render the Snapmint EMI details component

  return (
    emi_meta_data?.snapmint_total_eligible_amount > 0 && (
      <div className={`mt-2 bg-white px-3 py-3 rounded-lg`}>
        <p className="text-sm font-semibold text-[#000000] mb-2">EMI Payment Details </p>

        <div className={`grid ${order_status === "pending" ? "grid-cols-10" : "grid-cols-12"} items-center gap-x-20`}>
          <div className="col-span-4 flex flex-col gap-2">
            <div className="flex">
              <p className="text-xs">Total snapmint eligible amount :</p>
              <p className="text-xs font-medium flex items-center">
                <BsCurrencyRupee className="w-3 h-3" />
                <span className="text-black font-semibold">{emi_meta_data?.snapmint_total_eligible_amount}</span>
              </p>
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-xs">Mobile :</p>
              <NumberInput
                className="text-xs w-32"
                placeholder="Enter Mobile"
                maxLength={10}
                register={formHook.register(`mobile`, {
                  required: false,
                  ...forOnlyNumbersWithDecimal.validations,
                  validate: (value) => {
                    // Trim leading zeros
                    const trimmedValue = String(value).replace(/^0+/, "") || "0";
                    formHook.setValue(`mobile`, trimmedValue);
                    return null;
                  },
                })}
                fieldError={formState.errors.emi_collect_amount}
                errorMessages={[{ message: "", type: "required" }, forOnlyNumbersWithDecimal.errors]}
              />
            </div>
          </div>

          <div className={`flex items-center gap-5 mt-5 ${order_status === "pending" ? "col-span-6" : "col-span-6"} `}>
            <p className="flex items-center text-xs whitespace-nowrap">Amount to be Paid </p>
            <span className="pl-1">
              <NumberInput
                className="text-xs w-32"
                placeholder="Enter Amount"
                maxLength={6}
                disabled={order_status === "pending" || order_status === "settled"}
                max={emi_meta_data?.snapmint_total_eligible_amount}
                register={formHook.register(`emi_collect_amount`, {
                  required: false,
                  ...forOnlyNumbersWithDecimal.validations,
                  validate: (value) => {
                    // Trim leading zeros
                    const trimmedValue = String(value).replace(/^0+/, "") || "0";
                    formHook.setValue(`emi_collect_amount`, trimmedValue);

                    if (parseFloat(trimmedValue) > emi_meta_data?.snapmint_total_eligible_amount) {
                      return `Amount cannot exceed`;
                    }
                    return null;
                  },
                })}
                fieldError={formState.errors.emi_collect_amount}
                errorMessages={[{ message: "", type: "required" }, forOnlyNumbersWithDecimal.errors]}
              />
              <p className="text-red-400 text-[9px] absolute ">
                {parseFloat(formHook.watch(`emi_collect_amount`)) > emi_meta_data?.snapmint_total_eligible_amount &&
                  "Amount cannot exceed the total eligible amount"}
              </p>
            </span>

            {order_status === "pending" || order_status === "settled" ? null : (
              <CollectPaymentButton
                onClick={handleCollectPayment}
                customerMobile={customerMobile}
                setCustomerMobile={setCustomerMobile}
                disabled={emi_meta_data?.snapmint_total_eligible_amount <= 0}
                amount={emi_meta_data?.snapmint_total_eligible_amount}
                enterAmlount={formHook.watch(`emi_collect_amount`)}
                loading={isProcessing}
                mobile={formHook.watch("mobile")}
              />
            )}

            <div className="flex items-center gap-2 right-0 flex-end">
              {order_status === "failed" && (
                <p
                  className={` p-1 px-2 text-[#FF0000] bg-red-100    font-medium rounded-full border-transparent text-xs uppercase`}
                >
                  {order_status}
                </p>
              )}
              {order_status === "settled" && (
                <p
                  className={` p-1 px-2 text-[#149463] bg-green-100    font-medium rounded-full border-transparent text-xs uppercase`}
                >
                  {order_status}
                </p>
              )}
              {order_status === "pending" && (
                <p
                  className={` p-1 px-2 text-[#E0A200] bg-yellow-100    font-medium rounded-full border-transparent text-xs uppercase`}
                >
                  {order_status}
                </p>
              )}
            </div>
            <div className="flex justify-end">
              {order_status === "pending" && (
                <div className="flex items-center gap-4 flex-wrap">
                  {order_status === "pending" && (
                    <button
                      type="button"
                      className="cursor-pointer px-4 py-2 bg-black text-white rounded-lg border-transparent text-xs whitespace-nowrap flex-shrink-0"
                      onClick={(e) => handelFetchSnapmintEMIData(e)}
                    >
                      {emiStatusLoading ? <CircleSpinnerLoader h="20" w="125" /> : "Validate Payment"}
                    </button>
                  )}
                  <div className="flex-shrink-0">
                    <SnapmintPaymentCancelModal
                      removeSnapmintPaymentMethod={removeSnapmintPaymentMethod}
                      cancelPaymentInProgress={cancelPaymentInProgress}
                      order_status={order_status}
                    />
                  </div>
                  {isSMSbuttonVisible && (
                    <button
                      disabled={isSMSbuttonDisable}
                      className={`cursor-pointer flex-shrink-0 ${isSMSbuttonDisable ? "text-gray-400" : "text-green-500"}`}
                      onClick={(e) => sendSnapmintPaymentLink(e)}
                    >
                      <FaWhatsapp size={22} />
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default SnapmintIntegration;
